/**
 * 
 * @param item The item to be cloned
 * @returns Cloned Item
 */
export const deepClone = (item: object | Array<object | number | string | boolean>) => {
  if (structuredClone) {
    return structuredClone(item);
  }
  return JSON.parse(JSON.stringify(item));
};